import React from "react";
import { useLanguage } from "../hooks/useLanguage";

interface LanguageSwitcherProps {
  className?: string;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ className }) => {
  const { currentLanguage, supportedLanguages, languageNames, switchLanguage } =
    useLanguage();

  if (!supportedLanguages.length) {
    console.log("LanguageSwitcher: No supported languages found");
    return null;
  }

  // Handle language switch
  const handleLanguageSwitch = (lang: string) => {
    if (lang === currentLanguage) {
      return; // Already on this language
    }

    switchLanguage(lang);
  };

  return (
    <div className={`language-switcher ${className || ""}`}>
      <div className="language-switcher-container">
        {supportedLanguages.map((lang) => (
          <button
            key={lang}
            onClick={() => handleLanguageSwitch(lang)}
            className={`language-option ${
              lang === currentLanguage ? "active" : ""
            }`}
            aria-current={lang === currentLanguage}
          >
            {languageNames[lang] || lang}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
